<div id="chat-widget" class="chat-widget" x-data="chatWidgetContent">
    <div id="chat-widget-header" class="chat-widget-header">
        <div class="chat-widget-header-text" @switch-to-agent-chat.window="onSwitchToAgentChat">
            <p x-text="header"></p>
        </div>
        <div class="chat-widget-header-button">
            <button @click="toggleFullscreen"
                    title="Chat Vollbild"
                    id="toggle-fullscreen"
                    class="toggle-fullscreen">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" aria-hidden="true" viewBox="0 0 24 24" class="toggle-fullscreen-max">
                    <title/>
                    <path d="M10.22 12.72c.3-.3.76-.3 1.06 0 .27.26.3.68.07.98l-.07.08-4.16 4.15 2.81 2.81L1.5 22.5l1.76-8.43 2.8 2.8zM22.5 1.5l-1.76 8.43-2.8-2.8-4.16 4.15a.75.75 0 0 1-1.06 0 .74.74 0 0 1-.07-.98l.07-.08 4.15-4.16-2.8-2.8z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" aria-hidden="true" viewBox="0 0 24 24" class="toggle-fullscreen-min">
                    <title/>
                    <path d="m11.25 12.76-1.77 8.42-2.8-2.8-4.16 4.16a.75.75 0 0 1-1.06 0 .74.74 0 0 1-.07-.98l.07-.08 4.16-4.16-2.8-2.8zm10.23-11.3a.74.74 0 0 1 1.13.98l-.07.08-4.16 4.16 2.8 2.8-8.42 1.76 1.76-8.43 2.8 2.81z"/>
                </svg>
            </button>
            <button @click="minimizeChat"
                    title="minimieren"
                    id="minimize-button"
                    class="minimize-button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.53 14.04" width="25" height="25" aria-hidden="true" class="chat-widget-header-button-icon">
                    <polygon points="1.4 14.04 0 12.61 5.68 7.02 0 1.42 1.4 0 8.53 7.03 1.4 14.04"></polygon>
                </svg>
            </button>
        </div>
    </div>

    <div id="chat-widget-inner-content"></div>

</div>